import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledSearchForm, StyledSearchInput, StyledSearchButton } from "./SearchForm.styled";

const SearchForm = ({ onSearchClick }) => {
    const { t } = useTranslation();

    const [inputValues, setInputValues] = useState({
        title: '',
        last4Digits: '',
        buildingID: '',
        apartmentNumber: ''
    });
    const [searchBtnDisabled, setSearchBtnDisabled] = useState(true);

    const onInputChange = e => {
        setInputValues({
            ...inputValues,
            [e.target.name]: e.target.value
        })
    };

    useEffect(() => {
        const { title, buildingID, last4Digits, apartmentNumber } = inputValues;
        let isFormCorrectlyFilled = (title.length > 0 || buildingID.length > 0 || last4Digits.length === 4 || apartmentNumber.length > 0);
        setSearchBtnDisabled(!isFormCorrectlyFilled);
    }, [inputValues]);

    const onSearch = e => {
        onSearchClick(e, inputValues);
        const titles = Object.keys(inputValues);
        for (const title of titles) {
            localStorage.setItem(title, inputValues[title]);
        }
    };

    useEffect(() => {
        const get = name => localStorage.getItem(name);
        console.log(get('buildingID'))
        setInputValues({
            title: get('title') || '',
            last4Digits: get('last4Digits') || '',
            buildingID: get('buildingID') || '',
            apartmentNumber: get('apartmentNumber') || ''
        })
    }, []);

    return (
        <StyledSearchForm>
            <StyledSearchInput 
                placeholder={t('searchPayments.placeholders.address')} 
                value={inputValues.title} 
                name='title' 
                onChange={onInputChange} 
                autoFocus
            />
            <StyledSearchInput 
                placeholder={t('searchPayments.placeholders.buildingId')} 
                value={inputValues.buildingID} 
                name='buildingID' 
                onChange={onInputChange} 
            />
            <StyledSearchInput 
                placeholder={t('searchPayments.placeholders.fourDigits')} 
                type='number' 
                value={inputValues.last4Digits} 
                name='last4Digits' 
                onChange={onInputChange} 
            />
            <StyledSearchInput 
                placeholder={t('searchPayments.placeholders.apartmentNumber')} 
                type='number' 
                value={inputValues.apartmentNumber} 
                name='apartmentNumber' 
                onChange={onInputChange} 
            />
            <StyledSearchButton 
                onClick={onSearch} 
                disabled={searchBtnDisabled}
            >
                {t('searchPayments.btns.search')}
            </StyledSearchButton>
        </StyledSearchForm>
    );
};

export default SearchForm;
